import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const BusinessIntelligence = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Business Intelligence</h6>
          <hr />
          <h1 className="banner-title">
            Optimize Performance with Business <br /> Intelligence Solutions
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="./assets/img/3005.png"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-8">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell">Business Intelligence</h6>
                <h2 className="mt-3 mb-3">
                  Empower Smarter Decisions with Data-Driven Insights
                </h2>
                <p>
                  At <strong>Datafluent Analytics</strong>, we transform raw
                  data into actionable intelligence. Our innovative solutions
                  help businesses create better customer experiences, optimize
                  operations, and unlock new growth opportunities by leveraging
                  the power of analytics.
                </p>
              </div>
            </div>
            {/* <div className="col-md-6">
        <div className="about_pg1r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <a href="#">
                <img
                  src="https://img.freepik.com/free-photo/person-researching-market-trends-computer-taking-notes_73899-54551.jpg?t=st=1732020185~exp=1732023785~hmac=8e43b97b33142d6038fbb75f49ccaa164bc8dbcfed40c56e374091cb13734348&w=900"
                  className="w-100"
                  alt="Empowering Decisions"
                />
              </a>
            </figure>
          </div>
        </div>
      </div> */}
          </div>
        </div>
      </section>

      <section className="our-approach mt-3">
        <h2 className="approach-title">
          Our Approach to Business Intelligence
        </h2>
        <div className="approach-container">
          <div className="approach-step">
            <i className="fa fa-clipboard-check fa-3x" aria-hidden="true"></i>
            <h3>Understand Business Objectives</h3>
            <p>
              We align your unique business goals with a customized BI strategy.
            </p>
          </div>
          <div className="approach-step">
            <i className="fa fa-database fa-3x" aria-hidden="true"></i>
            <h3>Data Integration</h3>
            <p>
              We consolidate data from diverse sources into a unified,
              actionable platform.
            </p>
          </div>
          <div className="approach-step">
            <i className="fa fa-chart-line fa-3x" aria-hidden="true"></i>
            <h3>Interactive Dashboards</h3>
            <p>
              We create intuitive dashboards and reports for real-time
              decision-making.
            </p>
          </div>
          <div className="approach-step">
            <i className="fa fa-lightbulb fa-3x" aria-hidden="true"></i>
            <h3>Actionable Insights</h3>
            <p>
              We deliver insights that support strategic decisions and business
              growth.
            </p>
          </div>
          <div className="approach-step">
            <i className="fa fa-eye fa-3x" aria-hidden="true"></i>
            <h3>Continuous Monitoring</h3>
            <p>
              We track key metrics and refine strategies to ensure sustainable
              success.
            </p>
          </div>
        </div>
      </section>

      <section id="bi-tools" className="bi-tools py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">Tools We Use</h2>
          <div className="row mt-4">
            <div className="col-md-4 text-center">
              <img
                src="https://logos-world.net/wp-content/uploads/2022/02/Power-BI-Logo.png"
                alt="Power BI"
                className="img-fluid mb-3"
                style={{ maxWidth: "150px", maxHeight: "80px" }}
              />
              <h5>Power BI</h5>
            </div>
            <div className="col-md-4 text-center">
              <img
                src="https://logos-world.net/wp-content/uploads/2021/10/Tableau-Symbol-700x394.png"
                alt="Tableau"
                className="img-fluid mb-3"
                style={{ maxWidth: "150px", maxHeight: "80px" }}
              />
              <h5>Tableau</h5>
            </div>
            <div className="col-md-4 text-center">
              <img
                src="https://images.seeklogo.com/logo-png/39/1/google-looker-logo-png_seeklogo-394597.png?v=638675433310000000"
                alt="Looker"
                className="img-fluid mb-3"
                style={{ maxWidth: "150px", maxHeight: "80px" }}
              />
              <h5>Looker</h5>
            </div>
            {/* <div className="col-md-3 text-center">
        <img
          src="qlik-logo.png"
          alt="Qlik"
          className="img-fluid mb-3"
          style={{ maxWidth: "150px", maxHeight: "100px" }}
        />
        <h5>Qlik</h5>
      </div> */}
          </div>
        </div>
      </section>

      <hr />

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row serv_h1 mb-4 mt-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Our solutions</h3>
                <p className="mb-0">Our Customized Solutions</p>
              </div>
            </div>
          </div>
          <div className="menu mt-5">
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("overview")}
                className="scroll-link"
              >
                Transaction Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("sales-analytics")}
                className="scroll-link"
              >
                Sales Analytics
              </button>
              <span className="icon">⌄</span>
            </div>

            <div className="menu-item">
              <button
                onClick={() => scrollToSection("customer-analytics")}
                className="scroll-link"
              >
                Customer Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("workforce-analytics")}
                className="scroll-link"
              >
                Workforce Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
          </div>

          <div className="pt-5">
            <div id="overview" className="p_3">
              <h6 style={{ color: "#007bff" }}>Transaction Analytics</h6>
              <h4>Transaction Analytics for Smarter Decisions</h4>
              <hr />

              <div className="row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Transaction Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Tracking Patterns:</strong>
                      <ul>
                        <li>
                          Identifies trends, seasonal spikes, and customer
                          preferences.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Fraud Detection:</strong>
                      <ul>
                        <li>
                          Detects unusual transactions and real-time anomalies
                          with AI/ML.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Segmentation:</strong>
                      <ul>
                        <li>
                          Groups customers by behavior for targeted marketing.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Operational Optimization:</strong>
                      <ul>
                        <li>
                          Identifies inefficiencies and suggests workflow
                          improvements.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Revenue Insights:</strong>
                      <ul>
                        <li>
                          Analyzes sales and revenue for data-driven pricing and
                          product strategies.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Enhanced Decision-Making:</strong>
                      <ul>
                        <li>
                          Offers real-time insights into trends and customer
                          behavior.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Fraud Prevention:</strong>
                      <ul>
                        <li>
                          Minimizes financial losses and ensures secure
                          transactions.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Improved Customer Experience:</strong>
                      <ul>
                        <li>
                          {" "}
                          Provides personalized services and reduces errors.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Revenue:</strong>
                      <ul>
                        <li>
                          Boosts sales by targeting profitable segments and
                          trends. and more
                        </li>
                      </ul>
                    </li>

                    <li>
                      <strong>Operational Efficiency:</strong>
                      <ul>
                        <li>
                          Reduces errors, saves time, and optimizes resources.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="sales-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Sales Analytics</h6>
              <h3>Sales Analytics for Business Growth</h3>
              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Sales Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Performance Tracking:</strong>
                      <ul>
                        <li>
                          Monitors sales across products, regions, and time
                          periods.
                        </li>
                      </ul>
                    </li>

                    <li>
                      <strong>Forecasting:</strong>
                      <ul>
                        <li>
                          Predicts future sales using historical data and
                          trends.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Behavior Analysis:</strong>
                      <ul>
                        <li>Understands buying patterns and preferences.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Revenue Breakdown:</strong>
                      <ul>
                        <li>
                          Identifies contributions from products, services, and
                          segments.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Market Trends:</strong>
                      <ul>
                        <li>Aligns sales strategies with industry trends.</li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Improved Sales Strategies:</strong>

                      <ul>
                        <li>Enables targeted campaigns and pricing models.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Forecasting Accuracy:</strong>

                      <ul>
                        <li>
                          Provides reliable demand planning and inventory
                          management.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Boosted Revenue:</strong>

                      <ul>
                        <li>
                          {" "}
                          Highlights top-performing products and upselling
                          opportunities.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Optimized Resource Allocation:</strong>

                      <ul>
                        <li>Focuses on high-value sales opportunities.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Better Customer Relationships:</strong>

                      <ul>
                        <li>Offers personalized sales approaches.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="customer-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Customer Analytics</h6>
              <h3>Driving Business Growth through Customer Insights</h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Customer Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Customer Segmentation:</strong>
                      <ul>
                        <li>
                          Groups customers based on demographics, behavior, and
                          purchasing patterns.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Purchase Behavior Analysis:</strong>
                      <ul>
                        <li>
                          Analyzes customer buying habits, including frequency,
                          preferences, and spending patterns.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Lifetime Value (CLV) Prediction:</strong>
                      <ul>
                        <li>
                          Predicts the long-term value of customers based on
                          historical purchase data.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Churn Prediction:</strong>
                      <ul>
                        <li>
                          Identifies customers at risk of leaving and suggests
                          retention strategies.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Satisfaction Monitoring:</strong>
                      <ul>
                        <li>
                          Monitors customer feedback and satisfaction levels to
                          improve products and services.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Personalized Marketing:</strong>
                      <ul>
                        <li>
                          Enables targeted marketing campaigns based on customer
                          preferences and behaviors.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Customer Retention:</strong>
                      <ul>
                        <li>
                          Helps identify high-risk customers and implement
                          strategies to reduce churn.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Improved Product Offerings:</strong>
                      <ul>
                        <li>
                          Provides insights into customer needs, enabling the
                          development of better products and services.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Better Decision Making:</strong>
                      <ul>
                        <li>
                          Helps businesses make informed decisions about
                          pricing, promotions, and product launches.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Revenue:</strong>
                      <ul>
                        <li>
                          Improves sales strategies, boosting revenue through
                          better targeting and segmentation.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="workforce-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Workforce Analytics</h6>
              <h3>
                Optimizing Workforce Performance through Data-Driven Insights
              </h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Workforce Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Employee Performance Analysis:</strong>
                      <ul>
                        <li>
                          Measures employee performance and productivity levels
                          to identify high performers and areas for improvement.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Workforce Utilization:</strong>
                      <ul>
                        <li>
                          Analyzes how effectively the workforce is utilized,
                          identifying underused skills or resources.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Talent Management:</strong>
                      <ul>
                        <li>
                          Assesses the skill sets of employees and identifies
                          gaps in talent to guide recruitment and development
                          strategies.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Employee Engagement and Satisfaction:</strong>
                      <ul>
                        <li>
                          Tracks employee engagement and satisfaction through
                          surveys and feedback to improve workplace culture.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Turnover and Retention Analysis:</strong>
                      <ul>
                        <li>
                          Analyzes employee turnover patterns and identifies
                          factors contributing to employee attrition or
                          retention.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Improved Talent Acquisition:</strong>
                      <ul>
                        <li>
                          Helps companies identify the right skill sets needed
                          for recruitment, improving the hiring process.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Enhanced Employee Productivity:</strong>
                      <ul>
                        <li>
                          Identifies factors affecting productivity and enables
                          management to take actions to improve output.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Data-Driven Workforce Planning:</strong>
                      <ul>
                        <li>
                          Helps HR teams optimize workforce size, staffing
                          levels, and talent development strategies based on
                          data.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Employee Retention and Engagement:</strong>
                      <ul>
                        <li>
                          Improves employee retention by addressing factors
                          contributing to dissatisfaction and promoting
                          engagement.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Cost Optimization:</strong>
                      <ul>
                        <li>
                          Helps companies reduce costs by optimizing labor
                          costs, improving workforce scheduling, and reducing
                          turnover-related expenses.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "black", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                {/* <h6 className="">Benefits</h6> */}
                <h2 className="text-white">
                  Ready to Transform Your Business with BI?
                </h2>
                <p className="text-white mt-3">
                  Let’s discuss today how Business Intelligence can unlock your
                  company’s true potential.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="./assets/img/2007.png"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessIntelligence;
